import { render, staticRenderFns } from "./divCor.vue?vue&type=template&id=63200d4c&scoped=true&"
import script from "./divCor.vue?vue&type=script&lang=js&"
export * from "./divCor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63200d4c",
  null
  
)

export default component.exports